import React from "react";
import {
  cn,
  iconButtonBaseClass,
  iconButtonSizeClasses,
  iconButtonVariantClasses,
} from "./formStyles";

const IconButton = React.forwardRef(function IconButton({
  icon: Icon,
  label,
  variant = "ghost",
  size = "md",
  className = "",
  type = "button",
  children,
  ...props
}, ref) {
  return (
  <button
    ref={ref}
    type={type}
    aria-label={label}
    title={props.title || label}
    className={cn(
      iconButtonBaseClass,
      iconButtonSizeClasses[size] || iconButtonSizeClasses.md,
      iconButtonVariantClasses[variant] || iconButtonVariantClasses.ghost,
      className
    )}
    {...props}
  >
    {Icon ? <Icon size={16} /> : children}
  </button>
  );
});

export default IconButton;
